(function () {
    'use strict';

    angular.module('ecap.dashboards', []);

})();